<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content">
			<div class="columns column6">
				<h2 v-if="page.subtitle" class="subtitle">
					{{ page.subtitle }}
				</h2>
				<h1>{{ page.title || page.header }}</h1>
				<div v-parse-links v-html="page.content" />
			</div>
			<div class="columns column6">
				<iframe
					src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30398.835755442353!2d4.863543627553277!3d52.37102190942485!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c609d34b945f3f%3A0xd8a48a8fbee1e61b!2sdinette!5e1!3m2!1sen!2snl!4v1744195887832!5m2!1sen!2snl"
					width="100%"
					height="550"
					style="border: 0"
					allowfullscreen
					loading="lazy"
					referrerpolicy="no-referrer-when-downgrade"
				/>
			</div>
		</main-content>

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();

await fetchPage();

// const { data: form } = await useWebsiteFetch('contact', {
// 	query: { language: locale.value },
// 	key: `${locale.value}/contact`,
// });
</script>

<style lang="scss" scoped>
#maps {
	min-height: 600px;
}

.form-wrapper {
	padding: 40px 30px;
	background: var(--secondary-background-color);
}
</style>
